import useLocalStore from '../../../hooks/useLocalStore.js';
import FJVoiceCloning from '../view/FJVoiceCloning.jsx';
import { useSelector, useDispatch } from 'react-redux';
const FJVoiceCloningContainer = () => {
    useLocalStore();
    const createCloneStatus = useSelector(state => state.voiceCloning.createCloneStatus);

    return <FJVoiceCloning createCloneStatus={createCloneStatus} />;
};
export default FJVoiceCloningContainer;
